let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9J7yq")).then(() => parcelRequire('9d11S'));